import { useParams } from 'react-router-dom';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';

// AIDEV-NOTE: True during the window after a teacher switches question via the QuestionNavigator
// (URL questionId changes) but before QuestionGradingHooks writes the new question's data to the
// store. In that window `store.questionId`/`questionAnswers` are stale relative to the URL —
// callers should render a skeleton instead of the stale student-results list. Returns false during
// the initial page load (when `questionId` is null), since the page-level isLoading branch in
// QuestionGrading.tsx already covers that case.
const useIsQuestionTransitioning = (): boolean => {
  const { questionId: urlQuestionId } = useParams();
  const storeQuestionId = useGradingStore(state => state.questionId);

  return storeQuestionId != null && storeQuestionId.toString() !== urlQuestionId;
};

export default useIsQuestionTransitioning;
